/* eslint-disable operator-linebreak */
export const CERTIFICATION = "";
